import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { News } from '@app/entity';
import { NewsService } from '@app/core/services';
import { animations } from '@app/magazine/magazine-news/magazine-news.animations';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'app-magazine-news',
  animations: animations,
  templateUrl: './magazine-news.component.html',
  styleUrls: ['./magazine-news.component.scss']
})
export class MagazineNewsComponent implements OnInit, OnDestroy {
  news: News[] = [];
  isLoading = false;
  newsNext: string;
  ngUnsubscribe = new Subject();

  constructor(
    private route: ActivatedRoute,
    private newsService: NewsService,
  ) { }

  ngOnInit() {
    this.route.queryParams
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(params => {
      this.getNews(this.newsNext, params);
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  getNews(nextUrl?: string, filter?: object) {
    if (this.isLoading) return;
    this.isLoading = true;
    this.newsService.list(nextUrl, filter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .finally(() => this.isLoading = false)
      .subscribe(response => {
        this.news =  filter ? response.results : this.news.concat(response.results);
        this.newsNext = response.next;
      });
  }

  onScroll() {
    if (!this.newsNext) return;
    this.getNews(this.newsNext);
    this.newsNext = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/magazine/magazine-news/magazine-news.component.ts